import { Star } from 'lucide-react'

export function StarRating({ value, reviews }: { value: number; reviews: number }) {
  const full = Math.floor(value)
  const half = value - full >= 0.5
  const empty = 5 - full - (half ? 1 : 0)
  return (
    <div className="flex items-center gap-1 text-[13px]">
      <div className="flex items-center text-yellow-400">
        {Array.from({ length: full }).map((_, i) => (
          <Star key={`f-${i}`} className="w-3.5 h-3.5 fill-yellow-400" />
        ))}
        {half && (
          <div className="relative w-3.5 h-3.5">
            <Star className="absolute inset-0 w-3.5 h-3.5 text-slate-300" />
            <div className="absolute inset-0 overflow-hidden w-1/2">
              <Star className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
            </div>
          </div>
        )}
        {Array.from({ length: empty }).map((_, i) => (
          <Star key={`e-${i}`} className="w-3.5 h-3.5 text-slate-300" />
        ))}
      </div>
      <span className="text-muted">({reviews})</span>
    </div>
  )
}
